<template>
  <v-container fluid>
    <v-card>
      <app-overlay 
        :loading="loading"
      />
      <v-card-title primary-title v-if="siteId=='new'">
        New Site
      </v-card-title>
      <v-card-title primary-title v-else>
        Site {{ site.name }}
      </v-card-title>
      <v-form
        ref="form"
        lazy-validation
      >
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="4"
                style="padding-left: 50px; padding-right: 50px;"
              >
                <v-text-field
                  v-model="site.name"
                  label="Name"
                  :rules="nameRules"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row
              v-for="siteElement in siteElements"
              :key= "siteElement.name"
            >
              <v-col
                cols="12"
                md="4"
                style="padding-left: 50px; padding-right: 50px; "
              >
                <v-switch v-model="site['is'+siteElement.name+'Active']" :label="'Is '+siteElement.label+' Active'"></v-switch>
              </v-col>
              <v-col
                v-for="item in siteElement.items"
                :key="item"
                cols="12"
                md="4"
                style="padding-left: 50px; padding-right: 50px; "
              >
                <v-text-field
                  v-if="site['is'+siteElement.name+'Active'] == 1"
                  v-model="site[item]"
                  :label="item"
                ></v-text-field>
              </v-col>
                
              
            </v-row>
          </v-container>
        
        </v-card-text>
        <v-card-actions class="d-flex flex-row-reverse">
          <v-btn 
            @click="submit"
            rounded color="success" 
            style="margin: 10px"
            :loading="submitLoading"
            :disabled="submitLoading"
          >
            Save
          </v-btn>
          <v-btn rounded color="danger" @click="back" style="margin: 10px">Back</v-btn>
        </v-card-actions>
               
      </v-form>
    </v-card>
  </v-container>
  
</template>

<script>
  import axios from 'axios'
  import Overlay from './../../common/Overlay.vue'
  export default {
    components :{
      AppOverlay : Overlay
    },
    props: ['siteId'],
    data() {
      return {
        site: {
          id: ''
        },
        loading : false,
        nameRules: [v => !!v || 'Name is required'],
        submitLoading : false,
        siteElements: [
          { name: "Didomi", label: "Didomi", items: ["didomiId"]},
          { name: "Facebook",  label: "Facebook", items: ["facebookId"]},
          { name: "Mediarythmics", label: "Mediarythmics",items: ["mediarythmicsToken"]},
          { name: "Pubstack", label: "Pubstack", items: ["pubstackTagId"]},
          { name : 'Refresh', label: "Refresh",items: ['refreshCampaignIds']},
          { name: "Yieldkit", label: "Yieldkit", items: ["yieldkitSiteId"]},
          // { name: "Kvm", label: "Kvm", items: ["kvmEndpoint"]},
          { name: 'Permutive', label: "Permutive", items: []},
          //{ name : 'AdsWrapper', items: []},
          { name : 'Gravity', label: "Gravity", items: ["gravitySiteToken", "gravityProcessingToken"]},
          { name : 'TcfV2', label: "TcfV2", items: []},
          { name : 'Adagio', label: "Adagio", items: []},
          { name : 'RemoveHeaderOnOop', label: "Remove Header On Oop",items: []}
          
        ]
      }
    },
    watch:{
    },
    created(){
      if(this.$route.name == 'siteDetails') this.getDataFromApi()
    },
    methods: {
      async submit(){
        this.submitLoading = true
        if (!this.$refs.form.validate()) {
          console.log('No fullfilled')
          return;
        }
        if(this.site.isDidomiActive  == false) this.site.isDidomiActive = 0
        if(this.site.isFacebookActive  == false) this.site.isFacebookActive = 0
        if(this.site.isMediarythmicsActive == false) this.site.isMediarythmicsActive = 0
        if(this.site.isPubstackActive == false) this.site.isPubstackActive = 0
        if(this.site.isYieldkitActive == false) this.site.isYieldkitActive = 0
        if(this.site.isKvmActive == false) this.site.isKvmActive = 0
        if(this.site.isPermutiveActive == false) this.site.isPermutiveActive = 0
        //if(this.site.isAdsWrapperActive == false) this.site.isAdsWrapperActive = 0
        if(this.site.isGravityActive == false) this.site.isGravityActive = 0
        if(this.site.isAdagioActive == false) this.site.isAdagioActive = 0
        if(this.site.isRemoveHeaderOnOopActive == false) this.site.isRemoveHeaderOnOopActive = 0
        if(this.site.isRefreshActive == false) this.site.isRefreshActive = 0
         const request = {
            type : "management/site",
            action : "updateDetails",
            data : this.site
         }
         try{
           const accessToken = await this.$auth.getAccessToken()
          const response = await axios.post('/', JSON.stringify(request),{ headers: {Authorization: `Bearer ${accessToken}`}})
          if(response.data){
            this.submitLoading = false
            this.$router.push('/management')
          }
         } catch (e) {
          this.$router.push("/login")
        }

      },
      back(){
        this.$router.push('/management');
      },
      async getDataFromApi(){
        if(this.siteId == "new") {
          this.site = {
            id: '',
            name: '',
            isDidomiActive : '',
            didomiId: '',
            isFacebookActive: '',
            facebookId: '',
            isMediarythmicsActive: '',
            mediarythmicsToken: '',
            isPubstackActive: '',
            pubstackTagId: '',
            isYieldkitActive: '',
            yieldkitSiteId: '',
            isKvmActive : '',
            kvmEndpoint : '',
            isPermutiveActive: '',
            isAdsWrapperActive : '',
            isGravityActive: '',
            gravitySiteToken : '',
            gravityProcessingToken : '',
            isAdagioActive : '',
            isRemoveHeaderOnOopActive : '',
            isRefreshActive : '',
            isRefreshCampaignIds : ''
          }
          return
        }
        this.loading = true
        const request = {
          type : "management/site",
          action : "getDetails",
          data : {siteId : this.siteId }
        };
        try {
          const accessToken = await this.$auth.getAccessToken()
          const response = await axios.post('/', JSON.stringify(request),{ headers: {Authorization: `Bearer ${accessToken}`}})
          this.site = response.data
          this.loading= false
        } catch (e) {
          this.$router.push("/login")
        }
      }
    }
  }
</script>